module.exports = __webpack_public_path__ + "img/office--building.b5706c2d.svg";